<div class="label">
  <mb-icon class="icon" icon="exchange"></mb-icon>
  <div class="text">
    <h2> <ng-container *ngIf="currencyCode === 'USD';else msgPesos">
      Ver las opciones disponibles en pesos argentinos.
    </ng-container> </h2>
  </div>
</div>
<div class="button-redirect">
  <button mb-button variant="principal" color="secondary" (click)="redirectChangeCurrency()">
    <ng-container *ngIf="currencyCode === 'USD';else buttonDollar">
      Cambiar a pesos
    </ng-container>
  </button>
</div>

<ng-template #msgPesos>
  Comprá sin impuestos y percepciones pagando en dólares.
</ng-template>

<ng-template #buttonDollar>
 Cambiar a dólares
</ng-template>
